import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, CircularProgress, TextField } from '@mui/material';
import React, { SyntheticEvent, useEffect, useState } from 'react';

interface IOntimeAutocompleteProps<T> {
    onChange: ((event: SyntheticEvent<Element, Event>, value: T | null, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<T> | undefined) => void) | undefined;
    label: string;
    id: string | undefined;
    itemIdProperty: keyof T;
    itemLabelProperty: keyof T;
    valueId?: string;
    search(searchTerm: string): Promise<T[]>;
}
export default function OntimeAutocomplete<T>(props: IOntimeAutocompleteProps<T>) {
    const [items, setItems] = useState<T[]>([]);
    const [open, setOpen] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState<string>();
    const loading = open && items.length === 0;

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            let response: T[];
            if (searchTerm && searchTerm.length > 2) {
                response = await props.search(searchTerm);
            } else {
                response = [];
            }
            if (active) {
                setItems(response);
            }
        })();

        return () => {
            active = false;
        };
    }, [loading, searchTerm, props]);

    useEffect(() => {
        if (!open) {
            setItems([]);
        }
    }, [open]);

    return (
    <Autocomplete
        id={props.id}
        isOptionEqualToValue={(option:T, value:T) => option[props.itemIdProperty] === value[props.itemIdProperty]}
        getOptionLabel={(option:T) => String(option[props.itemLabelProperty])}
        options={items}
        loading={loading}
        onChange={props.onChange}
        open={open}
        onOpen={() => {
            setOpen(true);
        }}
        onClose={() => {
            setOpen(false);
        }}
        onInputChange={(e, value, reason) => setSearchTerm(value)}
        renderInput={(params) => (
            <TextField
                {...params}
                label={props.label}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <React.Fragment>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                        </React.Fragment>
                    )
                }}
            />
        )}
    />);
}